import { render, staticRenderFns } from "./AccordionList.vue?vue&type=template&id=50bd8cba&scoped=true"
import script from "./AccordionList.vue?vue&type=script&lang=js"
export * from "./AccordionList.vue?vue&type=script&lang=js"
import style0 from "./AccordionList.vue?vue&type=style&index=0&id=50bd8cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bd8cba",
  null
  
)

export default component.exports